<template>
  <el-dialog
    title="Добавить услугу"
    :visible="visible"
    :before-close="close"
    @opened="onOpen"
    width="620px"
  >
    <el-form ref="addForm" :rules="addFormRules" :model="addForm" class="dialog-form">
      <div class="dialog-form__title">Добавление новогой услуги</div>
      <el-form-item label="Название" prop="name">
        <el-input  name="name" ref="autoFocus" placeholder="Введите название" v-model="addForm.name"></el-input>
      </el-form-item>
      <el-form-item label="Описание" prop="name">
        <el-input  name="name" ref="autoFocus" placeholder="Введите описание..." v-model="addForm.name"></el-input>
      </el-form-item>
      <el-row :gutter="11">
        <el-col :span="8">
          <el-form-item label="Длительность" prop="name">
            <el-input  name="name" ref="autoFocus" placeholder="Введите описание..." v-model="addForm.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Стоимость" prop="name">
            <el-input  name="name" ref="autoFocus" placeholder="Введите описание..." v-model="addForm.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="H₵" prop="name">
            <el-input  name="name" ref="autoFocus" placeholder="Введите описание..." v-model="addForm.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="Влияние на системы организма" prop="type">
        <el-tag
          :key="tag"
          v-for="tag in dynamicTags"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)">
          {{tag}}
        </el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="mini"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        >
        </el-input>
        <el-button v-else type="primary" size="small" @click="showInput" class="button-new-tag">+ Добавить систему</el-button>
      </el-form-item>
      <el-form-item label="Противопоказания" prop="type">
        <el-select v-model="addForm.type" class="dialog__select">
          <el-option value="20" label="1" />
          <el-option value="40" label="2" />
          <el-option value="60" label="3" />
        </el-select>
      </el-form-item>
      <el-input
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 4}"
        placeholder="Введите комментарий..."
        v-model="comment">
      </el-input>
    </el-form>

    <footer-buttons mt>
      <el-button
        type="primary"
        :loading="loadAddForm"
        @click="saveForm(true)"
      >Создать новый прибор
      </el-button>
      <el-button
        :loading="loadBtn"
        @click="close"
      >Отмена
      </el-button>
    </footer-buttons>

  </el-dialog>
</template>

<script>
import FooterButtons from '@/components/dialog/FooterButtons'

export default {
  name: 'Service.Edit',
  data () {
    return {
      form: null,
      error: null,
      loadAddForm: false,
      loadBtn: false,
      comment: '',
      addForm: {
        type: '20'
      },
      addFormRules: {
        name: [
          { required: true, message: 'Укажите название', trigger: 'blur' }
        ],
        type: [{ required: true, message: 'Выберите роль', trigger: 'blur' }]
      },
      ///
      dynamicTags: ['Сердечно-сосудистая система', 'Название тега'],
      inputVisible: false,
      inputValue: ''
    }
  },
  mounted () {
  },
  props: {
    visible: {
      required: true
    }
  },
  components: {
    FooterButtons
  },
  methods: {
    onOpen () {
      this.autoFocus()
    },
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    close () {
      this.$emit('close')
    },
    autoFocus () {
      this.$refs.autoFocus.focus()
    },
    handleInputConfirm () {
      const inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    saveForm (close) {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.loadAddForm = !!1

          const er = this.$notify.error({
            title: 'Ошибка',
            message: 'Метод API отсутствует'
          })
          if (er) return

          const payLoad = {
            type: this.addForm.type,
            schema: {
              text: this.addForm.name,
              compendium: this.addForm.compendium
            }
          }
          this.$api.device
            .create(payLoad)
            .then(() => {
              this.$notify.success({
                title: 'Успешно',
                message: 'Данные сохранены'
              })
              if (close) {
                this.$emit('update')
                this.$emit('close')
              } else {
                this.$emit('update')
                this.addForm = {
                  type: '20'
                }
                this.autoFocus()
              }
            })
            .catch((response) => {
              this.$notify.error({
                title: 'Ошибка',
                message: response.response.data.message
              })
            })
            .finally(() => {
              this.loadAddForm = !!0
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

.dialog {
  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #aaaeba;
    margin: 25px 0 40px 0;

    &_mini {
      font-size: 14px;
    }
  }

  &__select {
    margin: 10px 0;
    width: 100%;
  }
  &__btns {
    float: right;
  }
}
.dialog-form {
  &__title {
    margin: 6px 0 24px 0;
    font-size: 15px;

    color: #909399;
  }
}
.el-button {
  margin-top: 5px;
}

.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
